import React from 'react';
import { WEB_MAX_CONTENT_WIDTH } from '../../theme/webLayoutWidths';
import { StyleProp, useWindowDimensions, ViewStyle } from 'react-native';
import { KeyboardAwareScrollView as RNKCKeyboardAwareScrollView } from 'react-native-keyboard-controller';
import { v } from '../../utils/libs';
import { shouldUseWidthConstraint } from '../../utils/layoutUtils';

type KeyboardAwareFormScrollProps = React.ComponentProps<
  typeof RNKCKeyboardAwareScrollView
> & {
  bottomOffset?: number;
  stickyOpenedOffset?: number;
  baseBottomPadding?: number;
  contentContainerStyle?: StyleProp<ViewStyle>;
};

const KeyboardAwareFormScroll: React.FC<KeyboardAwareFormScrollProps> = ({
  children,
  contentContainerStyle,
  bottomOffset,
  stickyOpenedOffset = v(130),
  baseBottomPadding = v(120),
  keyboardShouldPersistTaps = 'handled',
  ...rest
}) => {
  const { width, height } = useWindowDimensions();
  const constrainWidth = shouldUseWidthConstraint(width, height);

  const effectiveBottomOffset = Math.max(
    bottomOffset ?? stickyOpenedOffset + baseBottomPadding,
    baseBottomPadding,
  );

  const mergedContentContainerStyle: StyleProp<ViewStyle> = [
    contentContainerStyle,
    constrainWidth
      ? ({
          maxWidth: WEB_MAX_CONTENT_WIDTH,
          alignSelf: 'center',
          width: '100%',
        } as ViewStyle)
      : null,
    // { paddingBottom: effectiveBottomOffset },
  ];

  return (
    <RNKCKeyboardAwareScrollView
      keyboardShouldPersistTaps={keyboardShouldPersistTaps}
      bottomOffset={effectiveBottomOffset}
      contentContainerStyle={mergedContentContainerStyle}
      {...rest}>
      {children}
    </RNKCKeyboardAwareScrollView>
  );
};

export default KeyboardAwareFormScroll;
